import { PanelItemsService } from './../../services/panel-items/panel-items.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ConfirmationService } from 'primeng/api';
import { CookieService } from 'ngx-cookie-service';
import { PanelsService } from 'src/app/services/panels/panels.service';
import * as CryptoJS from 'crypto-js';
import { Variables } from 'src/app/Models/variables';

@Component({
  selector: 'app-panel-items',
  templateUrl: './panel-items.component.html',
  styleUrls: ['./panel-items.component.css']
})
export class PanelItemsComponent implements OnInit {

  loading = false;
  page = 1;
  size = 100;
  panels = [];

  isLoadMore = false;
  pid: number;
  load = false;

  isadm = false;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private configService: ConfigurationService,
    private notificationSvc: NotificationService,
    private confirmationService: ConfirmationService,
    private cookieService: CookieService,
    private panelItemService: PanelItemsService
  ) {
    // this.translate.addLangs(['English', 'French']);
    // this.translate.setDefaultLang('English');

    // let browserLang = this.translate.getBrowserLang();

    // const pass = 'ranitessarldev2019';
    // const lang = cookieService.get('goepla-portal-language');
    // if (lang.trim() !== '') {
    //   const declang = CryptoJS.AES.decrypt(lang, pass).toString(CryptoJS.enc.Utf8);
    //   const lg = declang;
    //   browserLang = lg;
    // }

    // if (localStorage.getItem('language') !== null) {
    //   browserLang = localStorage.getItem('language');
    // }
    // this.translate.use(browserLang.match(/English|French/) ? browserLang : 'English');

    translate.use('English');

    this.pid = +localStorage.getItem('panel-id');
    this.getPanelItems();
   }

  ngOnInit() {
    localStorage.removeItem('panel-item');
  }

  gotoCreatePanelItem() {
    this.router.navigateByUrl('/createpanelitem');
  }

  getPanelItems() {
    this.loading = true;
    this.load = true;
    // tslint:disable-next-line: deprecation
    this.panelItemService.getPanels(this.page, this.size, this.pid).subscribe((res) => {
      if (res != null) {
        const v = new Variables();
        const gis = localStorage.getItem('gi');
        const gs = CryptoJS.AES.decrypt(gis, v.pass).toString(CryptoJS.enc.Utf8);
        const gids = JSON.parse(gs);

        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < res.length; i++) {
          // let isedit = false;
          // if (res[i].typeRoleGroups !== null && res[i].typeRoleGroups.length > 0) {
          //   for (const val of res[i].typeRoleGroups) {
          //     if (val.typeRoleGroup.roleName === 'Administrator' && gids.includes(val.typeRoleGroup.groupId)) {
          //       isedit = true;
          //     }
          //   }
          // }
          const options = [];
          // tslint:disable-next-line: deprecation
          this.translate.get('GENERAL.DETAILS').subscribe((res1) => {
            // tslint:disable-next-line: deprecation
            this.translate.get('GENERAL.DELETE').subscribe((res2) => {
              // tslint:disable-next-line: deprecation
              this.translate.get('GENERAL.EDIT').subscribe((res3) => {
                options.push({label: res1, value: 'Details'});
                options.push({label: res3, value: 'Edit'});
                options.push({label: res2, value: 'Delete'});

                res[i].options = options;
                this.panels.push(res[i]);
              });
            });
          });
        }
        if (res.length < this.size) {
          this.isLoadMore = true;
        } else {
          this.isLoadMore = false;
        }
      } else {
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.NOPANELITEMS').subscribe((resp: string) => {
          this.notificationSvc.info('', resp, 3000);
          this.isLoadMore = true;
        });
      }
      this.loading = false;
      this.load = false;
    }, err => {
      this.handleError(err);
    });
  }

  loadMore() {
    this.page += 1;
    this.getPanelItems();
  }

  deletePanel(panel) {
    this.load = true;
    // tslint:disable-next-line: deprecation
    this.panelItemService.deletePanel(panel.panelId).subscribe((res) => {
      if (res === true) {
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.PANELITEMDELETED').subscribe((resp: string) => {
          this.notificationSvc.info('', resp, 3000);
        });
        this.panels = [];
        this.getPanelItems();
      } else {
        this.load = false;
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.COULDNOTDELETEPANELITEM').subscribe((resp: string) => {
          this.notificationSvc.info('', resp, 3000);
        });
      }
    }, err => {
      this.handleError(err);
    });
  }

  savePanel(event, panel) {
    localStorage.setItem('panel-item', JSON.stringify(panel));
    if (event.value === 'Details') {
      this.router.navigateByUrl('/panelitemdetail');
    } else if (event.value === 'Edit') {
      this.router.navigateByUrl('/editpanelitem');
    } else if (event.value === 'Delete') {
      // tslint:disable-next-line: deprecation
      this.panelItemService.deletePanel(panel.id).subscribe((res) => {
        if (res === true) {
          // tslint:disable-next-line: deprecation
          this.translate.get('GENERAL.PANELITEMDELETED').subscribe((resp: string) => {
            this.notificationSvc.info('', resp, 3000);
          });
          this.panels = [];
          this.getPanelItems();
        } else {
          // tslint:disable-next-line: deprecation
          this.translate.get('GENERAL.COULDNOTDELETEPANELITEM').subscribe((resp: string) => {
            this.notificationSvc.info('', resp, 3000);
          });
        }
      }, err => {
        this.handleError(err);
      });
    }
  }

  confirm(msg) {
    this.confirmationService.confirm({
        message: msg,
        accept: () => {
            // Actual logic to perform a confirmation
        }
    });
  }

  handleError(err) {
    this.load = false;
    this.loading = false;
  }

}
